export default __webpack_public_path__ + "static/winter35-02194294d61c26f73dfcaf6c2fd28139.webp";